import { createRouter, createWebHistory } from 'vue-router';

import { useAuthStore, useAlertStore } from '@/stores';
import { pinia } from '@/stores/pinia';
import { Home } from '@/views';
import accountRoutes from './account.routes';
import sector from '@/router/sector.routes';
import exchange from '@/router/exchange.routes';
import stock from '@/router/stock.routes';
import trade from '@/router/trade.routes';
import platform from '@/router/platform.routes';
import investmentPlan from '@/router/investment_plan.routes';
import scheduler from '@/router/scheduler.routes';
import configuration from '@/router/configuration.routes';
import tracker from '@/router/tracker.routes';
import importData from '@/router/import.routes';
import bond from '@/router/bond.routes';
import performance from '@/router/performance.routes';
import gapBacktest from '@/router/gap-backtest.routes';
import orderLog from '@/router/order-log.routes';
import notification from '@/router/notification.routes';

const baseUrl = ``;

export const router = createRouter({
    history: createWebHistory(baseUrl),
    linkActiveClass: 'active',
    routes: [
        { path: '/', component: Home },
        { ...accountRoutes },
        { ...sector },
        { ...exchange },
        { ...stock },
        { ...trade },
        { ...platform },
        { ...investmentPlan },
        { ...scheduler },
        { ...configuration },
        { ...tracker },
        { ...importData },
        { ...bond},
        { ...performance},
        { ...gapBacktest},
        { ...orderLog},
        { ...notification},
        // catch all redirect to home page
        { path: '/:pathMatch(.*)*', redirect: '/' }
    ]
});

router.beforeEach(async (to) => {
    // clear alert on route change
    const alertStore = useAlertStore(pinia);
    alertStore.clear();

    // redirect to login page if not logged in and trying to access a restricted page
    const publicPages = ['/account/login'];
    const authRequired = !publicPages.includes(to.path);
    const authStore = useAuthStore(pinia);

    if (!to || !to.path) {
        console.error(`❌ ERROR: Route is undefined`, to);
    }

    if (authRequired && !authStore.user) {
        authStore.returnUrl = to.fullPath;
        return '/account/login';
    }
});
